var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEvents = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "m23.43 13.278-1.348 5.995-3.515-5.124M29.33 10.294l.905 5.924-5.129-3.566M16.25 14.171l-3.276 5.22-1.665-5.963"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#464646"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.7 13.064a26.3 26.3 0 0 0 6.7 1.127q.39.014.8.014c3.536 0 8.162-.81 12.339-4.1M21.64 24.97l-4.06 4.695-.67-6.178M28.316 25.13l-2.096 5.633-2.848-5.543M14.804 22.56l-5.371 3.168 1.37-6.064"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.384 17.285c.529.635 2.714 3.104 6.255 5.133 2.605 1.492 6.333 2.952 10.946 2.952 1.941 0 4.042-.263 6.28-.888"
})))));
export default SvgEvents;